import React from 'react';
import ReactDOM from 'react-dom';
import { AppWrapper } from './components/App';

ReactDOM.render(<AppWrapper />, document.getElementById('root'));
